// ==============================|| OVERRIDES - FORM HELPER TEXT ||============================== //

export default function FormHelperText() {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: 4,
          marginLeft: 0,
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: 400,
        },
      },
    },
  };
}
